import { render, staticRenderFns } from "./RelatorioPedido.vue?vue&type=template&id=e732bd02"
import script from "./RelatorioPedido.vue?vue&type=script&lang=js"
export * from "./RelatorioPedido.vue?vue&type=script&lang=js"
import style0 from "./RelatorioPedido.vue?vue&type=style&index=0&id=e732bd02&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports